














import { Vue, Component, Prop } from 'vue-property-decorator'
import store from 'src/assets/store'
import { select } from 'components/presenter/item/ParentSelect.vue'
import api from 'src/assets/api/gql'
import ItemMove from 'src/graphql/item/ItemMove.gql'
import { Item, ItemType } from 'src/graphql/types'

@Component
export default class PresenterLayoutMenuButtonMove extends Vue {

  get item () {
    return store.state.presenter.item!
  }

  async action () {
    const parentId = await select(this, {
      title: this.$t('item.edit.move').toString(),
      item: this.item,
      type: ItemType.Folder
    })
    const { data: { updateItemMove } } = await api.mutate({
      query: ItemMove,
      variables: {
        id: this.item.id,
        parentId: parentId || 0
      }
    })
    if (updateItemMove && updateItemMove.item) {
      store.presenterSetItem(updateItemMove.item)
    }
  }
}
